import * as yup from 'yup';
import { BaseEntitySchema } from './IBaseEntity';

export const SuggestionSchema = yup.object({
  isEditable: yup.boolean().default(true),
  values: yup.array(yup.string().required()).default([]),
});
export type ISuggestion = yup.InferType<typeof SuggestionSchema>;

export const UpdateSuggestionSchema = BaseEntitySchema.concat(SuggestionSchema);
export type IUpdateSuggestion = yup.InferType<typeof UpdateSuggestionSchema>;
